module.exports = __webpack_public_path__ + "static/media/Icon ionic-ios-warning-yellow.e1319d46.svg";